(function () {
  'use strict';

  function formatDate(ts) {
    try {
      return new Date(ts).toLocaleString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
    } catch (e) {
      return new Date(ts).toString();
    }
  }

  function initPanel(panel) {
    var storageKey = panel.getAttribute('data-storage-key') || 'bz_cookie_consent';
    var toggles = Array.prototype.slice.call(panel.querySelectorAll('[data-cookie-toggle]'));
    var statusEl = panel.querySelector('[data-cookie-status]');
    var statusDefault = statusEl ? statusEl.textContent.trim() : '';
    var savedTemplate = panel.getAttribute('data-status-saved-template');

    function readStored() {
      try {
        var raw = window.localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function writeStored(consent) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(consent));
      } catch (e) { /* storage unavailable — fail silently */ }
    }

    function currentConsent() {
      var consent = { necessary: true, savedAt: null };
      toggles.forEach(function (t) {
        consent[t.getAttribute('data-key')] = t.checked;
      });
      return consent;
    }

    function applyConsent(consent) {
      toggles.forEach(function (t) {
        var key = t.getAttribute('data-key');
        var value = consent && Object.prototype.hasOwnProperty.call(consent, key)
          ? !!consent[key]
          : t.getAttribute('data-default') === 'on';
        t.checked = value;
        updateToggleLabel(t);
      });
    }

    function updateToggleLabel(toggle) {
      var label = toggle.closest('.bz-toggle');
      var stateEl = label && label.querySelector('[data-toggle-state]');
      if (!stateEl) return;
      var onLabel = panel.getAttribute('data-state-on-label') || 'On';
      var offLabel = panel.getAttribute('data-state-off-label') || 'Off';
      stateEl.textContent = toggle.checked ? onLabel : offLabel;
    }

    function setStatus(saved) {
      if (!statusEl) return;
      if (saved) {
        var text = savedTemplate
          ? savedTemplate.replace('{date}', formatDate(Date.now()))
          : 'Saved on ' + formatDate(Date.now()) + '.';
        statusEl.textContent = text;
        statusEl.setAttribute('data-state', 'saved');
      } else {
        statusEl.textContent = statusDefault;
        statusEl.removeAttribute('data-state');
      }
    }

    function persist() {
      var consent = currentConsent();
      consent.savedAt = Date.now();
      writeStored(consent);
      setStatus(true);
      panel.dispatchEvent(new CustomEvent('boldzee:cookieConsentChanged', {
        bubbles: true,
        detail: consent
      }));
    }

    // initial state: use a saved choice if one exists, otherwise each block's default
    var stored = readStored();
    applyConsent(stored);
    if (stored && stored.savedAt) {
      setStatus(true);
    }

    // each toggle saves immediately on change
    toggles.forEach(function (t) {
      t.addEventListener('change', function () {
        updateToggleLabel(t);
        persist();
      });
    });

    var acceptAllBtn = panel.querySelector('[data-cookie-accept-all]');
    if (acceptAllBtn) {
      acceptAllBtn.addEventListener('click', function () {
        toggles.forEach(function (t) { t.checked = true; updateToggleLabel(t); });
        persist();
      });
    }

    var rejectOptionalBtn = panel.querySelector('[data-cookie-reject-optional]');
    if (rejectOptionalBtn) {
      rejectOptionalBtn.addEventListener('click', function () {
        toggles.forEach(function (t) { t.checked = false; updateToggleLabel(t); });
        persist();
      });
    }

    var saveBtn = panel.querySelector('[data-cookie-save]');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        persist();
      });
    }
  }

  function init() {
    var panels = document.querySelectorAll('[data-cookie-panel]');
    panels.forEach ? panels.forEach(initPanel) : Array.prototype.forEach.call(panels, initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();